import { render, staticRenderFns } from "./TATable-web.vue?vue&type=template&id=9aba16cc&scoped=true&"
import script from "./TATable-web.vue?vue&type=script&lang=js&"
export * from "./TATable-web.vue?vue&type=script&lang=js&"
import style0 from "./TATable-web.vue?vue&type=style&index=0&id=9aba16cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aba16cc",
  null
  
)

component.options.__file = "TATable-web.vue"
export default component.exports